import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from '../../../../services';
import { JobcardService } from '../../../../services/jobcard.service';

@Component({
  selector: 'app-link-jobcards',
  templateUrl: './link-jobcards.component.html',
  styleUrls: ['./link-jobcards.component.scss'],
})
export class LinkJobcardsComponent implements OnInit {
  @Input() jobcard;
  @Input() partnerID;

  services: any[] = [];
  public partnerData: any = {};

  constructor(
    public jobcardService: JobcardService,
    private helpersService: HelpersService,
  ) {}

  ngOnInit() {
    this.partnerData = this.helpersService.getPartnerData();

    this.jobcardService
      .getJobCardsToLink(this.partnerID, this.jobcard.ID)
      .subscribe((result) => {
        var obj = JSON.parse(result);
        this.services = obj;
        //console.log(obj);
      });
  }

  LinkOrUnlink(LinkServiceID) {
    this.jobcardService
      .getLinkJobCard(this.partnerID, this.jobcard.ID, LinkServiceID)
      .subscribe((result) => {
        var obj = JSON.parse(result);
        this.services = obj;
      });
  }
}
